import { ControlOutlined, ProjectOutlined } from '@ant-design/icons'
import {
    SearchOutlined,
    DatabaseOutlined,
    ReadOutlined,
} from '@ant-design/icons'
import { makeStyles } from '@material-ui/core'
import { Layout, Menu } from 'antd'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import { useData } from '../../../data'
import { useRouter } from '../../../routes'
import PageHeader from './header'


const { Sider, Content } = Layout
const { SubMenu } = Menu

/** Layout styles */
const useStyles = makeStyles(theme => ({
    layout: {
        // height: '100%',
        width: '100%',
        background: '#FFF'
    },
    logo: {
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'start',
        flexDirection: 'column',
        padding: theme.spacing(1, 4)
    },
    logoImage: {
        height: 100,
        marginTop: 8,
        marginBottom: 16,
        width: 100,
    },
    logoImageSmall: {
        height: 35,
        marginTop: 8,
        marginBottom: 16,
        width: 35,
    },
    title: {
        fontSize: 30,
        fontWeight: 700,
        margin: theme.spacing(3, 0, 2, 0),
    },
    subtitle: {
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: '24px',
        color: '#1F66EF'
    },
    content: {
        // padding: theme.spacing(4),
        background: '#F4F7FC',
    },
    sidebar: {
        // height: '100%',
        minHeight: '100vh',
        //boxShadow: '0px 1px 4px rgba(21, 34, 50, 0.08)'
    },
    sidebarMenu: {
        marginTop: theme.spacing(2)
    },
    bottomSection: {
        [theme.breakpoints.up('lg')]: {
            marginTop: theme.spacing(10)
        }

    }
}))

/**
 * General dashboard layout component
 *
 * Renders the sidebar component and page component passed
 */
const DashboardLayout = ({ children, selected }) => {
    // track collapsed state
    const [collapsed, setCollapsed] = useState(sessionStorage.getItem('sidebar_collapsed') === 'true')
    const [user, setUser] = useState(null)

    const classes = useStyles()
    const router = useRouter()
    const data = useData()
    const auth = data.auth()

    // get the currently logged in user
    useEffect(() => {
        trackPromise(
            auth.getCurrentUser().then(setUser).catch(err => {
                router.replace('/')
            })
        )
        // eslint-disable-next-line
    }, [])

    /**
     * Navigate to the given url
     * @param {string} url url to navigate
     * @returns new route stack on top
     */
    const goTo = url => () => router.push(url)

    // logout
    const logout = () => {
        trackPromise(
            auth.signout()
                .then(() => router.replace('/'))
                .catch(() => router.replace('/'))
        )
    }

    const { promiseInProgress } = usePromiseTracker()

    const onSidebarCollapseChange = (collapsed) => {
        sessionStorage.setItem('sidebar_collapsed', collapsed)
        setCollapsed(collapsed)
    }


    return (
        <Layout className={classes.layout} >
            <PageHeader logout={logout} user={user} />

            <Layout className='site-layout' style={{ marginTop: 64 }}>
                <Sider
                    className={classes.sidebar}
                    width={210}
                    theme="light"
                    collapsible
                    collapsed={collapsed}
                    onCollapse={onSidebarCollapseChange}
                >
                    {/* <div className={classes.logo}>
                        <img src="/apple-touch-icon.png" alt="logo" className={collapsed ? classes.logoImageSmall : classes.logoImage} />
                        <h2 className={classes.subtitle}>{collapsed ? 'LGS' : 'Lead Generation System'}</h2>
                    </div> */}

                    <Menu theme="light" mode="inline" defaultSelectedKeys={[selected]} selectedKeys={[selected]} defaultOpenKeys={['source']} className={classes.sidebarMenu}>
                        {/* <SubMenu key="source" icon={<HomeFilled />} title="Source"> */}
                        <Menu.Item key="tools" onClick={goTo('/dashboard')} icon={<ControlOutlined />} > Tools</Menu.Item>
                        <Menu.Item key="jobs" onClick={goTo('/dashboard/jobs')} icon={<ProjectOutlined />}> Jobs</Menu.Item>
                        <Menu.Item key="cookies" onClick={goTo('/dashboard/cookies')} icon={<ProjectOutlined />}>Cookies</Menu.Item>
                        <Menu.Item key="tlr" onClick={goTo('/dashboard/tlr')} icon={<ProjectOutlined />}>TLR</Menu.Item>
                        <Menu.Item key="titles" onClick={goTo('/dashboard/titles')} icon={<ProjectOutlined />}>Titles</Menu.Item>

                        {/* </SubMenu> */}

                        {/* <SubMenu key="search" icon={<SearchOutlined />} title="Search">
                            <Menu.Item key="companies_search"> <BankOutlined /> Companies</Menu.Item>
                            <Menu.Item key="people_search"> <TeamOutlined /> People</Menu.Item>
                            <Menu.Item key="jobs_search"> <ProjectOutlined /> Jobs</Menu.Item>
                        </SubMenu> */}


                        {/* <Menu.Item key="send" icon={<SendOutlined />}>Send</Menu.Item> */}

                        {/* <Menu.Divider />
                        <SubMenu key="user" icon={<UsergroupAddOutlined />} title="Management" className={classes.bottomSection}>
                            <Menu.Item key="profile" icon={<UserOutlined />} onClick={goTo('/dashboard/profile')} >Profile</Menu.Item>
                            {
                                user && user.is_superuser && <Menu.Item key="admin" icon={<UserSwitchOutlined />} onClick={goTo('/dashboard/admin')} >Admin</Menu.Item>
                            }
                            <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={logout}>{promiseInProgress ? 'Loading...' : 'Logout'}</Menu.Item>
                        </SubMenu> */}

                    </Menu>
                </Sider>

                <Content className={classes.content}>
                    {children}
                </Content>
            </Layout>

        </Layout>
    )
}

DashboardLayout.propTypes = {
    children: PropTypes.element
}

//export layout components here
export { default as DashboardPage } from './dashboard_page'

export default DashboardLayout
